/** Shared portal sidebar menu filtering (partner / workspace / executive). */

export function pathMatchesNavItem(pathname, to) {
  if (!to || to === "#") return false;
  if (pathname === to) return true;
  return pathname.startsWith(`${to}/`);
}

const FRANCHISE_ADMIN_PERMISSIONS = new Set([
  "view_dashboard",
  "view_complaints",
  "view_store_kpis",
]);

export function filterPortalMenuItems(items, permissionService, options = {}) {
  const { dashboardOnly = false, dashboardOnlyKeys = [] } = options;

  return (items || []).filter((item) => {
    if (dashboardOnly) {
      return dashboardOnlyKeys.includes(item.key);
    }

    if (item.adminOnly && !permissionService.isAdmin()) return false;
    if (item.superAdminOnly && !permissionService.isSuperAdmin()) return false;
    if (item.hideForSuperAdmin && permissionService.isSuperAdmin()) return false;
    if (item.franchiseCreateOnly && !permissionService.canCreateFranchiseUsers()) return false;
    if (
      item.regionScopeAccess &&
      !(permissionService.isSuperAdmin() || permissionService.canCreateFranchiseUsers())
    ) {
      return false;
    }
    if (item.requiresWhatsapp && !permissionService.canUseWhatsappCredentials()) return false;

    if (item.userOnly && permissionService.isAdmin()) {
      if (!(item.allowSuperAdmin && permissionService.isSuperAdmin())) return false;
    }

    if (item.adminPermission && permissionService.isFranchise()) {
      return FRANCHISE_ADMIN_PERMISSIONS.has(item.adminPermission);
    }

    if (item.adminPermission === "manage_products" && !permissionService.canManageProducts()) return false;
    if (item.adminPermission === "manage_services" && !permissionService.canManageServices()) return false;
    if (item.adminPermission === "view_dashboard" && !permissionService.canViewDashboard()) return false;
    if (item.adminPermission === "view_store_kpis" && !permissionService.canViewStoreKpis()) return false;
    if (item.adminPermission === "view_complaints" && !permissionService.canViewComplaints()) return false;
    if (item.adminPermission === "view_contact_messages" && !permissionService.canViewContactMessages()) return false;
    if (item.adminPermission === "company_profile" && !permissionService.canEditCompanyProfile()) return false;
    if (item.adminPermission === "edit_set_flow" && !permissionService.canEditSetFlow()) return false;
    if (item.adminPermission === "manage_kiosk_landings" && !permissionService.canManageKioskLandings()) return false;
    if (item.adminPermission === "manage_terms" && !permissionService.canManageTerms()) return false;
    if (item.adminPermission === "manage_skin_settings" && !permissionService.canManageSkinSettings()) return false;
    if (item.adminPermission === "manage_ai_chat" && !permissionService.canManageAiChat()) return false;

    if (!item.permission) return true;
    if (Array.isArray(item.permission)) return permissionService.hasAny(...item.permission);
    return permissionService.has(item.permission);
  });
}
